import { z } from 'zod'

import { getSearchDefaultIntegration } from '@wwt/core/admin'
import {
	GuestQuantityDto,
	IntegrationsSearchDto
} from '@wwt/entities/api/search-response'
import { ActiveFilters } from '@wwt/entities/filters'
import {
	defaultFlagSearch,
	defaultGeolocation,
	defaultGuestQuantity,
	defaultPagination,
	defaultStay
} from '@wwt/shared/config'

import { FlagSearchCoerceSchema } from './FlagSearchCoerce.ts'
import { GeolocationCoerce } from './GeolocationCoerce.ts'
import { PaginationCoerceSchema } from './PaginationCoerce.ts'
import { searchRequestStaySchema } from './SearchRequestStay.ts'

export const SearchRequest = z.object({
	pagination: PaginationCoerceSchema.default(defaultPagination),
	stay: searchRequestStaySchema.default(defaultStay),
	geolocation: GeolocationCoerce.default(defaultGeolocation),
	guestQuantity: GuestQuantityDto.default(defaultGuestQuantity),
	sortBy: z.string().optional(),
	filters: ActiveFilters.optional(),
	flagSearch: FlagSearchCoerceSchema.default(defaultFlagSearch),
	integrationsSearch: IntegrationsSearchDto.default(getSearchDefaultIntegration)
})

export type SearchRequest = z.infer<typeof SearchRequest>

export const SearchRequestParams = z.object({
	search: SearchRequest.optional().default({})
})

export type SearchRequestParams = z.infer<typeof SearchRequestParams>
